var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[(!_vm.isDynamic)?_c('span',{staticClass:"flag-icon",class:_vm.flagClass}):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.html)}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.flagClass)?_c('span',{staticClass:"flag-icon",class:_vm.flagClass}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.model.user.registered_with_ip)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }